import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setGetRezyme} from '../../store/thunk/setGetRezyme';
import TableCasino from './block/table';
import {ReactComponent as ArrowRight} from '../../../../../@casino/img/right-arrow.svg';
import {ReactComponent as ArrowDown} from '../../../../../@casino/img/down-arrow.svg';
import {columns, useStyles, getRows} from './helpers';

const BlockBet = ({id}) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const [rezyme, setRezyme] = React.useState(false);

    React.useEffect(() => {
        if (rezyme) {
            dispatch(setGetRezyme({
                id,
                page: 1,
                rowsPerPage: 5
            }))
        }
    }, [rezyme, id])

    const rezymeArr = useSelector(state => state.users.rezyme);
    const rows = React.useMemo(() => getRows(rezymeArr.data), [rezymeArr]);
    
    return (
        <div>
            <div 
                className={classes.wrapTitle}
                onClick={() => {
                    setRezyme(!rezyme)
                }}
            >
                <span
                    className={classes.title}
                >
                    Резюме за все время
                </span>
                {
                    !rezyme && 
                    <ArrowRight className={classes.arrow}/>
                }
                {
                    rezyme && 
                    <ArrowDown className={classes.arrow}/> 
                }   
            </div>
            <div>
                {
                    rezyme && id &&
                    <TableCasino 
                        allPage={rezymeArr.count}
                        pagination
                        width={1280}
                        perPage={5}
                        columns={columns}
                        rows={rows}
                        changePage={(v) => dispatch(setGetRezyme({
                            page: 1,
                            rowsPerPage: v.rowsPerPage,
                            id
                        }))}
                        changeRowsPerPage={(v) => dispatch(setGetRezyme({
                            page: 1,
                            rowsPerPage: v.rowsPerPage,
                            id
                        }))}
                    /> 
                }
            </div>       
        </div>
    )
}

export default BlockBet;